module.exports = __webpack_public_path__ + "assets/dd8870c232da23fd9b828e22c5f0c9a3.mp3";